// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__O1t0t","image":"Product_image__JkU5l","brand":"Product_brand__zYBRb","name":"Product_name__1U9ov","cta":"Product_cta__2kDKH"};